<template>
  <b-modal title="Lista de Manutenções" v-model="show" size="lg">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TEMPLATES :::::::::::::::::::::::::::: -->
      <b-table
        id="table-checklist-temp"
        sticky-header
        style="max-height: 400px"
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterPlano(filtro)"
        :fields="fields.planoTemplate"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="load(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>

    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="med-filter-tmp"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Descrição"
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useTemplateStore } from "@/stores/TemplateStore";
import TableFields from "@/tools/TableFields";

export default {
  name: "PlanoManutencaoTemplateModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      template: { id: 0, descricao: "", itens: [] },
      filtro: "",
    };
  },

  methods: {
    load(dados) {
      this.template.id = dados.id;
      this.template.descricao = dados.descricao;
      this.template.itens = [];
      this.templateStore.LISTAR_ITENS_PLANO(dados.id).then(() => {
        for (var i = 0; i < this.getPlanoItens.length; i++) {
          this.template.itens.push({
            id: this.getPlanoItens[i].id,
            intervalo: this.getPlanoItens[i].intervalo,
            item: this.getPlanoItens[i].item,
            planomanutencao: this.getPlanoItens[i].planomanutencao,
          });
        }
        this.$emit("loadTemplate", this.template);
        this.show = !this.show;
      });
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();
    const { getPlanoItens } = storeToRefs(templateStore);
    const { getFilterPlano } = storeToRefs(templateStore);

    return {
      store,
      templateStore,
      getPlanoItens,
      getFilterPlano,
    };
  },
};
</script>

<style lang="scss" scoped>
#med-filter-tmp {
  width: 22rem;
}
</style>
